/**
 * @name          Site Search
 * @version       1.0
 * @lastmodified  2015-06-11
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JR, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'searchAutoSuggest',
		defaults = {
			url: 'http://search.voith.com/web/ig-voith/json/suggestions.json',
			submitButtonClass: '.sitesearch__inputSubmit',
			inputClass: '.sitesearch__input',
			searchFormCloseClass: '.sitesearch__closeSearch',
			resultsClass: '.sitesearch__searchResults',
			innerResultsClass: '.sitesearch__innerResults',
			resultLimitDefault: 8,
			resultLimitTall: 12,
			resultLimitNarrow: 8,
			resultLimitTallOneFacette: 12,
			resultLimitNarrowOneFacette: 8,
			resultLimitSmall: 6,
			resultThreshold: 685,
			inputDelay: 200,
			minChar: 1
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);
		this.init();
	}

	// methods
	var methods = {
		init: function () {
			var self = this;

			// init all search relevant elements
			this.$submitButtonClass = this.$element.find(self.options.submitButtonClass);
			this.$searchInput = this.$element.find(this.options.inputClass);
			this.$searchReset = this.$element.find(this.options.searchFormCloseClass);
			this.$searchForm = self.$element.closest('form');
			this.$resultsBox = this.$element.find(this.options.resultsClass);
			this.$innerResults = this.$element.find(this.options.innerResultsClass);
			this.serviceURL = this.$element.data('autosuggestions-url') || this.options.url;
			this.autosuggestIsDisplayed = false;

			// key codes for autosuggest
			this.keyEnter = 13;
			this.keyUp = 38;
			this.keyDown = 40;
			this.keyEsc = 27;

			// prevent submitting input text by pressing enter key if autosuggest item is selected
			this.$searchForm.on('keydown', function (e) {
				var code = e.keyCode || e.which;

				if (code === self.keyEnter) {
					var $hover = self.$innerResults.find('a.hover');
					if (self.autosuggestIsDisplayed && $hover.length > 0) {
						e.preventDefault();
						self.triggerSearchResultLink($hover);
					}
					self.abortPendingAutosuggest();
					self.hideResultsBox();
				}
			});

			// init keyup event
			this.$searchInput.on('keyup.search', function (e) {
				var $this = $(this);
				var code = e.keyCode || e.which;

				// clear pending timeout for autosuggest request
				clearTimeout($this.data('timer'));

				// check if pressed key has no autosuggest control function
				if ($.inArray(code, [self.keyEnter, self.keyEsc, self.keyUp, self.keyDown]) === -1) {

					// get autosuggests or reset input view
					var value = $(this).val();
					if (value.length >= self.options.minChar) {
						// reset and re-init delayed autosuggestions
						$this.data('timer', setTimeout(function () {
							$this.removeData('timer');
							self.getAutosuggestions(value, e);
						}, self.options.inputDelay));

						// show close icon
						self.$searchReset.show();
						self.$searchInput.addClass('has-resetbtn');
					} else {
						// abort pending search request
						self.abortPendingAutosuggest();

						// hide result list
						self.hideResultsBox();

						// hide close icon
						self.$searchReset.hide();
						self.$searchInput.removeClass('has-resetbtn');
					}
					//  check if pressed key is one of autosuggest controls
				} else if (self.autosuggestIsDisplayed && $.inArray(code, [self.keyEsc, self.keyUp, self.keyDown]) >= 0) {
					self.handleKeyboardActions(e);
				}
			});

			// on mouseenter check if autosuggest-link with hover class (set by keyboard controls) exists
			this.$innerResults.on('mouseenter', 'a', function () {
				var $hover = self.$innerResults.find('.hover');

				if ($hover.length > 0) {
					$hover.removeClass('hover');
				}
			});

			this.$submitButtonClass.on('click', function () {
				clearTimeout(self.$searchInput.data('timer'));
				self.abortPendingAutosuggest();
				self.hideResultsBox();
			});

			this.$innerResults.on('click', 'a', function (e) {
				e.preventDefault();

				self.triggerSearchResultLink($(this));
			});

			// init reset input click
			this.$element.closest('.sitesearch').on('reset.input.sitesearch', function() {
				if (self.autosuggestIsDisplayed) {
					self.$searchReset.hide();
					clearTimeout(self.$searchInput.data('timer'));
					self.abortPendingAutosuggest();
					self.hideResultsBox();
				}
			});

			$(window).on('hideResultBox', function (e) {
				self.hideResultsBox();
			});

			// limit results to 12 or 16 results depending on viewportheight
			this.resultLimit = this.options.resultLimitDefault;
			this.resultLimitOneFacette = this.options.resultLimitNarrowOneFacette;
			enquire.register('screen and (min-height: ' + this.options.resultThreshold + 'px)', {
				match: function () {
					self.resultLimit = self.options.resultLimitTall;
					self.resultLimitOneFacette = self.options.resultLimitTallOneFacette;
				},
				unmatch: function () {
					self.resultLimit = self.options.resultLimitNarrow;
					self.resultLimitOneFacette = self.options.resultLimitNarrowOneFacette;
				}
			});
		},

		abortPendingAutosuggest: function () {
			// abort autosuggest ajax request
			if (this.searchRequest) {
				this.searchRequest.abort();
				this.searchRequest = null;
			}
		},

		hideResultsBox: function () {
			this.$resultsBox.hide().css({'height': '0'}).find('.sitesearch__innerResults').html('');
			$('.page').off('click.hideResultsBox');
			this.autosuggestIsDisplayed = false;
		},

		triggerSearchResultLink: function ($link) {

			var self = this;
			var linkText = $link.text();
			var linkHref = $link.attr('href');
			var q = $.deparam(linkHref)['?q'];
			linkHref = linkHref + '&actualQ=' + q;

			self.$searchInput.val(linkText);

			var filter = decodeURIComponent(getURLParameter('filter', linkHref));
			if (filter !== '') {
				jQuery('input.suggestions_filter').remove();
				self.$searchInput.after('<input name="filter" class="suggestions_filter suggestions-ignore" value="' + filter + '" type="hidden"/>');
			}
			self.$searchInput.parent().find('button').trigger('click');
			self.$element.trigger('productServiceFinder.update');

			self.hideResultsBox();
		},

		getAutosuggestions: function (value) {
			var self = this;

			var getParams = 'keyword=' + encodeURIComponent(value) + '&lang=' + self.getCurrentLanguageId();
			/*
			 if (ui.configuration.get('global.touch')) {
			 getParams += '&touch=true';
			 }*/

			self.$element.find('input[type="hidden"]:not(".suggestions-ignore")').each(function () {
				getParams += '&' + jQuery(this).attr('name') + '=' + jQuery(this).val();
			});

			this.abortPendingAutosuggest();
			this.searchRequest = $.ajax({
				url: self.serviceURL,
				data: getParams,
				dataType: 'json',
				beforeSend: function (xhr) {
				},
				error: function (xhr, ajaxOptions, thrownError) {
				},
				success: function (json) {

					// helper array, will hold json copy
					var facettesData = [];
					// totalHits = all hits in json response
					var totalHits = 0;
					// hits are limited to 8/12 or 12/16 (only one facette) entries
					var limitResult = self.resultLimit;
					var limitResultOneFacette = self.resultLimitOneFacette;

					// hbs template
					var resultTemplate = global.configuration.get('tpl.globalSearchResult');
					// empty result list/remove previous results
					self.$innerResults.html('');

					// check for response with results
					if (json.results.length > 0) {

						// get totalHits and copy filled facettes in jsonLimited
						$.each(json.results, function (index, element) {

							// if element exists push it helper array
							if (element.hits.length > 0) {
								facettesData.push(element);
								totalHits += element.hits.length;
							}
						});

						// change limit if onlx one facette is in result
						// hide facette if result has only one facette
						var hideFacetteTitle;
						if (facettesData.length <= 1) {
							hideFacetteTitle = true;
							limitResult = limitResultOneFacette;
						}

						// check if totalHits is less than our default
						if (totalHits < limitResult) {
							limitResult = totalHits;
						}

						// facette in facettesData
						var facette = 0;
						// entry in facettes
						var entry = 0;
						// valid result counter
						var results = 0;

						while (results < limitResult) {

							// check for entry
							if (facettesData[facette].hits[entry]) {
								// store in showEntries the number of entries to be displayed
								facettesData[facette].showEntries = entry + 1;
								// increase result counter
								results++;
							}

							// next facette
							facette++;

							// go to first facette if end is reached
							if (facette === facettesData.length) {
								facette = 0;
								// look for next entry in facette
								entry++;
							}
						}

						// build entries:
						$.each(facettesData, function (index, element) {

							// slice result to max length per facette
							var hitsLimited = element.hits.slice(0, element.showEntries);

							// obj for hbs template
							var resultBlockData = {
								headline: element.headline,
								hideHeadline: hideFacetteTitle,
								hits: hitsLimited
							};

							var $resultBlock = $(resultTemplate(resultBlockData));
							// append reultblock to DOM
							self.$innerResults.append($resultBlock);
						});

						// show box and highlight query string in resultslist
						self.$resultsBox.show().find('a').highlight(value);

						var heightInner = self.$innerResults.outerHeight() + 30;
						self.$resultsBox.css({'height': heightInner + 'px'});
						self.autosuggestIsDisplayed = true;
					} else {
						self.$resultsBox.hide().css({'height': '0'});
						self.$innerResults.html('');
						self.autosuggestIsDisplayed = false;
					}
					self.closeOnClickOuter();
				}
			});
		},

		getCurrentLanguageId: function () {
			return window['global'].configuration.get('currentLanguageId').toLowerCase();
		},

		closeOnClickOuter: function () {
			var self = this;
			$('.page').on('click.hideResultsBox', function () {
				self.hideResultsBox();
				self.autosuggestIsDisplayed = false;
			});
		},

		handleKeyboardActions: function (event) {
			var code = event.keyCode || event.which;
			var $hover = this.$innerResults.find('a.hover');

			switch (code) {
			case this.keyUp: // up
				if ($hover.length > 0) {
					if (!$hover.closest('li').is(':first-child')) {
						// if list item is not first-child get previous list item and add hover class
						$hover.removeClass('hover').closest('li').prev().find('a').addClass('hover');
					} else {
						// if list item is first-child check if there is a previous result group
						if (!$hover.closest('.search-result-group').is(':first-child')) {
							$hover.removeClass('hover').closest('.search-result-group').prev().find('ul:last-of-type li:last-child a').addClass('hover');
						}
					}
				} else {
					// if no hover class exists set class to first list item of first result group
					this.$innerResults.find('.search-result-group:last-child').find('ul:last-of-type li:last-child a').addClass('hover');
				}
				break;

			case this.keyDown: // down
				if ($hover.length > 0) {
					if (!$hover.closest('li').is(':last-child')) {
						// if list item is not last-child get next list item and add hover class
						$hover.removeClass('hover').closest('li').next().find('a').addClass('hover');
					} else {
						// if list item is last-child check if there is a next result group
						if (!$hover.closest('.search-result-group').is(':last-child')) {
							$hover.removeClass('hover').closest('.search-result-group').next().find('ul:first-of-type li:first-child a').addClass('hover');
						}
					}
				} else {
					// if no hover class exists set class to last list item of first result group
					this.$innerResults.find('.search-result-group:first-child').find('ul:first-of-type li:first-child a').addClass('hover');
				}
				break;

			case this.keyEsc: // escape
				this.abortPendingAutosuggest();
				this.hideResultsBox();
				break;
			default:
				break;
			}
		}
	};

	function getURLParameter(param, queryString) {
		queryString = queryString === null ? '' : queryString;
		var r = new RegExp('(^|\\?|&+)' + param + '(=[^&]*)?(?=&|$)', 'g').exec(queryString);
		return r && r[2] ? r[2].substring(1) : '';
	}

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function (options) {
		this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				// trigger ready event on element
				$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally
		if (this.length > 0) {
			$.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		}

		return this;
	};

})(jQuery, window, document);
